import { AxiosInstance } from "axios";

class CustomersAdditionalFieldsApi {
    api: AxiosInstance;

    constructor(api) {
        this.api = api;
    }

    async list(customerId, pageNumber, pageSize) {
        return await this.api.fetch({
            method: "get",
            url: `/admin/additional-fields/`,
            urlVersion: 3,
            params: {
                customer_id: customerId,
                ...(pageNumber ? { page_number: pageNumber } : {}),
                ...(pageSize ? { page_size: pageSize } : {}),
            },
        });
    }

    async add(customerId, data) {
        return await this.api.fetch({
            method: "post",
            url: `/admin/additional-fields/`,
            urlVersion: 3,
            params: { customer_id: customerId },
            data,
        });
    }

    async update(customerId, id, data) {
        return await this.api.fetch({
            method: "put",
            url: `/admin/additional-fields/${id}/`,
            urlVersion: 3,
            params: { customer_id: customerId },
            data,
        });
    }

    async delete(customerId, id) {
        return await this.api.fetch({
            method: "delete",
            url: `/admin/additional-fields/${id}/`,
            urlVersion: 3,
            params: { customer_id: customerId },
        });
    }
}

export default CustomersAdditionalFieldsApi;
